import BrandLogo from "@/components/common/BrandLogo";

/**
 * Straight from the manifest, so `bun dev` and a production build show the same
 * number and bumping it means editing one line in package.json.
 */
import { version as APP_VERSION } from "../../package.json";

/**
 * Deliberately outside the router and outside the auth check: this page is how
 * you tell which build is live, so it has to answer even when the API is down.
 */
export default function AboutPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background p-6 text-center">
      <BrandLogo iconSize={48} textWidth={170} gap={0} />

      <div className="flex flex-col gap-1">
        <p className="text-sm font-medium tracking-wide text-muted-foreground uppercase">Version</p>
        <p className="text-4xl font-semibold tabular-nums">{APP_VERSION}</p>
      </div>
    </div>
  );
}
